export const STEP_STYLE = {
  width: 'min-content',
  minWidth: '80%',
  maxWidth: '100%',
  margin: '0 auto',
  marginBottom: '100px'
  // height: '600px',
};
export const STEP_BODY_STYLE = {
  minHeight: '500px'
};